export class ProjectType {
    constructor(
    public projectTypeId: string,
    public projectTypeName: string
    ){}
}
